import type { Game } from '../../game/Game';
import { registerOverlay, registerPanel } from '../../ui/app/App';
import { setGame } from '../economy/ui';
import { InstanceClient } from './client';
import { registerInstanceContent } from './content';
import { InstanceDeath, InstanceHud, InstanceResult } from './InstanceHud';
import { InstancesPanel, setPanelGame } from './InstancesPanel';
import './instances.css';

/**
 * Instanced content runtime: story dungeon clears, Rift Delve, Colossus
 * Hunts, the Deepvault, the Warlord Siege and the Crucible (zone scripts
 * following the multiplayer contract), the `instances` panel (opened by the
 * `dungeon` / `arena` NPC services) and the instance HUD overlays.
 */

let installed: InstanceClient | null = null;

/** The installed client (debugging: `__AF__` scripts can reach the active instance script through it). */
export const instanceClient = (): InstanceClient | null => installed;

export function install(game: Game): void {
  if (installed?.game === game) return;
  registerInstanceContent();
  const client = new InstanceClient(game);
  installed = client;
  setGame(game);
  setPanelGame(game);
  registerPanel('instances', InstancesPanel);
  for (const o of [InstanceHud, InstanceDeath, InstanceResult]) registerOverlay(o);
  game.zoneSetups.push((_g, z, opts) => client.setup(z, opts));
  game.systems.push((_g, dt) => client.system(dt));
  const prev = game.interactHandlers.get('station');
  game.interactHandlers.set('station', (g, id) => client.handleStation(id) || (prev?.(g, id) ?? false));
  client.wrapEnterInstance();
}

export { ACTIVITIES, entryStatus } from './catalog';
export { RIFT, COLOSSUS, GATE, CRUCIBLE } from './rules';
export type { InstanceEnv } from './env';
